if (!customElements.get("op-header-wrapper")) {
    customElements.define("op-header-wrapper", class extends HTMLElement {
        connectedCallback () {
            this.lastScrollTop = 0;
            this.headerHidden = false;
            this.headerFlag = true;
            this.headerGroup = this.closest(".js-headerGroup");
            this.headerEl = this.querySelector("header");
            this.headerBlocks = this.querySelectorAll("[data-header-block]");
            this.logoWrapper = this.querySelector("[data-logo-wrapper]");
            this.scrollLogo = this.querySelector("[data-scroll-logo]");
            this.staticLogo = this.querySelector("[data-static-logo]");
            this.showSearchBtns = this.querySelectorAll("[data-show-search]");
            this.showCartBtns = this.querySelectorAll("[data-cart-ic-id]");
            this.accountAnchor = this.querySelector("[data-account-anchor]");
            this.isFrostedSurface = this.dataset.headerSurfaceStyle === "frosted";
            
            this.isTransparentOnTop = this.hasAttribute("data-transparent-on-top");
            this.blockBgClass = this.headerEl?.getAttribute("data-block-bg-class");
            this.separatorClass = this.headerEl?.getAttribute("data-separator-class");
            this.hideOnScroll = this.headerEl?.hasAttribute("data-hide-on-scroll");
            this.sectionId = this.headerEl?.getAttribute("data-section-id");
            this.headerSearch = document.querySelector("#headerSearch-" + this.sectionId);

            this.showCartBtn_handler = (e) => this.showCart(e);
            this.showSearchBtn_handler = () => this.showSearch();
            this.window_scrollHandler = () => this.updateHeaderScroll();

            window.addEventListener("scroll", this.window_scrollHandler);
            this.showSearchBtns.forEach(btn => btn.addEventListener("click", this.showSearchBtn_handler));

            if (this.showCartBtns.length > 0) {
                this.showCartBtns.forEach(btn => btn.addEventListener("click", this.showCartBtn_handler));
                this.setCartBtnId(this.showCartBtns[0].getAttribute("data-cart-ic-id"));
            }
            
            if (this.isTransparentOnTop) {
                this.staticLogo?.classList.remove("tw-hidden");
                this.updateHeaderScroll();
            } else {
                this.applyStaticHeaderLogoOverride();
            }
            this.setupLoginModal();

            this.updateOffsetValue();
            this.updateHeaderSurfaceScrollState(window.scrollY || document.documentElement.scrollTop);
            this.window_resizeHandler = () => this.updateOffsetValue();
            window.addEventListener("resize", this.window_resizeHandler);
        }

        disconnectedCallback () {
            window.removeEventListener("scroll", this.window_scrollHandler);
            this.showSearchBtns.forEach(btn => btn.removeEventListener("click", this.showSearchBtn_handler));
            window.removeEventListener("resize", this.window_resizeHandler);
        }

        setCartBtnId (id) {
            if (this.showCartBtns.length > 0 && id && !document.getElementById(id)) {
                this.showCartBtns[0].id = id;
            }
        }

        showCart (clickEvent) {
            const cartDrawerWrapper = document.querySelector("cart-drawer");

            if (cartDrawerWrapper) {
                clickEvent.preventDefault();
                cartDrawerWrapper.open(clickEvent.target);
            }
        }

        showSearch () {
            this.headerSearch?.classList.add("show");
        }

        toggleScrollLogo (scrolling) {
            if (this.scrollLogo && this.staticLogo) {
                this.scrollLogo.style.display = scrolling ? "block" : "none";
                this.staticLogo.style.display = scrolling || this.getStaticHeaderLogoOverride() === "hide" ? "none" : "block";
            }
        }

        getStaticHeaderLogoOverride () {
            const overrideSource = document.querySelector("[data-static-header-logo-override]");
            return overrideSource?.dataset.staticHeaderLogoOverride;
        }

        applyStaticHeaderLogoOverride () {
            if (this.getStaticHeaderLogoOverride() === "hide") {
                if (this.staticLogo) this.staticLogo.style.display = "none";
            }
        }

        updateOffsetValue() {
            this.offsetValue = window.innerWidth >= 1024 ? 24 : 16;
        }

        updateHeaderSurfaceScrollState(scrollYPos) {
            if (this.isFrostedSurface) {
                this.dataset.surfaceScrolled = scrollYPos > 0;
            }
        }

        updateHeaderScroll () {
            const target = this.headerGroup || this.headerEl;
            const headerOffsetHeight = this.headerGroup ? this.headerGroup.offsetHeight : this.headerEl.offsetHeight;
            const scrollYPos = window.scrollY || document.documentElement.scrollTop;
            const scrolled = scrollYPos > headerOffsetHeight;
            const isScrollingDown = scrollYPos > this.lastScrollTop;
            const fixedToHeaderModalOpTrigger = document.querySelector('[data-filter-header-fixed]');

            this.updateHeaderSurfaceScrollState(scrollYPos);

            const getTargetScroll = (elements) => {
                return elements.reduce((acc, el) => {
                    if(!el) return acc;
                    
                    const height = el.getBoundingClientRect().height;
                    return acc + height;
                }, 0)
            }

            const targetScroll = getTargetScroll([this.headerEl, this.headerGroup]);

            if (this.isTransparentOnTop) {
                this.toggleScrollLogo(scrolled);
            } else {
                this.applyStaticHeaderLogoOverride();
            }

            if (this.separatorClass) {
                this.headerGroup?.classList.toggle(this.separatorClass, scrolled);
            }

            if (this.blockBgClass && this.isTransparentOnTop) {
                this.headerBlocks.forEach(block => {
                    if (!block.hasAttribute("data-prevent-bg-change")) {
                        block.classList.toggle(this.blockBgClass, scrolled);
                    }
                });
            }

            if (this.hideOnScroll && scrollYPos > 0) {
                if (isScrollingDown) {
                    if(this.headerFlag) {
                        this.headerFlag = false;
                        setTimeout(() => {
                            this.headerHidden = false;
                            target.classList.remove("tw-transition-transform");
                        }, 150);
                    }
                    // this.headerGroup.style.top = isScrollingDown ? `-${this.headerGroup.clientHeight}px` : "0";
                    if(!this.headerHidden) target.classList.remove("tw-transition-transform");
                    else target.classList.add("tw-transition-transform");
                    if(!this.headerSearch?.classList.contains("show"))
                        target.style.transform = scrolled ? "translateY(-100%)" : `translateY(-${scrollYPos}px)`;
                    fixedToHeaderModalOpTrigger?.classList.add('tw-hidden');
                } else {
                    this.headerHidden = true;
                    this.headerFlag = true;
                    // this.headerEl.style.top = isScrollingDown ? `-${this.headerEl.offsetHeight}px` : "0";
                    target.classList.add("tw-transition-transform");
                    if(!this.headerSearch?.classList.contains("show"))
                        target.style.transform = "translateY(0)";

                    fixedToHeaderModalOpTrigger?.classList.remove('tw-hidden');
                    fixedToHeaderModalOpTrigger && (fixedToHeaderModalOpTrigger.style.transform =`translateY(${headerOffsetHeight + this.offsetValue}px)`);

                    if(scrollYPos < targetScroll) {
                        fixedToHeaderModalOpTrigger?.classList.add('tw-hidden');
                    }
                }

                this.toggleAttribute("data-scroll-hidden", isScrollingDown);
            } else {
                if(!this.headerSearch?.classList.contains("show"))
                    // Header frosted: hide-on-scroll e' disabilitato, quindi translateY(0) e'
                    // un no-op visivo che pero' crea un containing block e intrappola il
                    // pannello DDM (position: fixed) sotto l'announcement bar durante e dopo
                    // l'animazione. Usiamo "none" -> l'header non e' mai containing block,
                    // il DDM resta a viewport top:0 per tutta l'animazione.
                    target.style.transform = this.isFrostedSurface ? "none" : "translateY(0)";
                this.toggleAttribute("data-scroll-hidden", false);
            }

            this.dataset.scrolling = scrolled;
            this.dataset.isTransparent = !scrolled && this.isTransparentOnTop;

            this.lastScrollTop = scrollYPos;
        }

        setupLoginModal() {
            const loginModal = document.querySelector("#login-overlay-modal");
            if (loginModal && typeof loginModal.showModal === "function" && !window.location.pathname.includes("account/login")) {
                this.accountAnchor?.addEventListener("click", (e) => {
                    e.preventDefault();
                    if (loginModal.dataset.position === "right") loginModal.classList.add('tw-animate-slide-left');
                    loginModal.showModal();
                });
            }
        }
    });
}